export default "__VITE_ASSET__3ejTAyhy__"